import { z } from 'zod';
// The RD-verification verdict. Source of truth for the enum used across the
// backend (rd-verify, doc-ingest detectAnomaly) + web (verdict chip). Order is
// load-bearing for the test that asserts RdVerdictSchema.options.
export const RdVerdictSchema = z.enum([
    'VERIFIED',
    'NOT_VAT_REGISTERED',
    'NAME_MISMATCH',
    'BRANCH_MISMATCH',
    'INVALID_TAX_ID',
    'UNKNOWN',
    'DISABLED',
]);
export const RdVerifySourceSchema = z.enum(['RD_SOAP', 'CSV_SNAPSHOT', 'MANUAL', 'NONE']);
// The attach-to-proposal verification result (locked cross-phase contract).
// All match fields are nullable: UNKNOWN/DISABLED/NOT_VAT_REGISTERED carry nulls.
export const RdVerifyResultSchema = z.object({
    verdict: RdVerdictSchema,
    found: z.boolean(),
    registeredName: z.string().nullable(),
    branchName: z.string().nullable(),
    branchNumber: z.string().nullable(),
    addressTh: z.string().nullable(),
    businessFirstDate: z.string().nullable(),
    matchScore: z.number().nullable(),
    source: RdVerifySourceSchema,
    checkedAt: z.string(),
});
//# sourceMappingURL=rd-verify.js.map